/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureUserNoticeModel } from './restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

const destructUserNoticeList = (state, responseJson) => {
  if (!responseJson.success) {
    return {
      response: responseJson,
      destructData: null
    };
  }
  return {
    response: responseJson,
    destructData: {
      itemsById: _.keyBy(
        _.map(responseJson.data.items, item =>
          restructureUserNoticeModel(state, item)
        ),
        'id'
      ),
      itemsIds: _.map(responseJson.data.items, item => item.id),
      pagination: restructurePaginationModel(_.get(responseJson, 'data._meta'))
    }
  };
};

class EventsUserNoticeService {
  async getMe(state, queryParams) {
    const response = await api.get('/events-user-notice/me', {
      ...{
        expand: 'type,type_category,event'
      },
      ...queryParams
    });
    const responseJson = await response.json();
    return destructUserNoticeList(state, responseJson);
  }

  async getMeNotRead(state) {
    const response = await api.get('/events-user-notice/me', {
      expand: 'type,type_category,event',
      notice_app_status: 1
    });
    const responseJson = await response.json();
    return destructUserNoticeList(state, responseJson);
  }

  async setRead(state, arg) {
    const response = await api.post(
      `/events-user-notice/set-read/${arg}`,
      {},
      {}
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async getNotice(state, noticeId) {
    const response = await api.get(`/events-user-notice/${noticeId}`, {
      expand: 'type,type_category,event'
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        [noticeId]: restructureUserNoticeModel(state, responseJson.data)
      }
    };
  }
}

export default new EventsUserNoticeService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/services/EventsUserNoticeService/EventsUserNoticeService.js